/**
 * @generated SignedSource<<f68bbdae396cae56c4d297437525ca34>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type toolTipArticleSpeechWidgetToolTipArticle$data = {
  readonly entityId: string;
  readonly " $fragmentType": "toolTipArticleSpeechWidgetToolTipArticle";
};
export type toolTipArticleSpeechWidgetToolTipArticle$key = {
  readonly " $data"?: toolTipArticleSpeechWidgetToolTipArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"toolTipArticleSpeechWidgetToolTipArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "toolTipArticleSpeechWidgetToolTipArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "9ce3c40a4e2cb15bd30d5cf63d2b8548";

export default node;
